// src/WhoWeArePage.jsx
import React, { useState, useEffect } from 'react';
import PageHeader from './PageHeader';
import styles from './WhoWeArePage.module.css';
import axios from 'axios';

const API_BASE_URL = 'https://kigaawater.inkenya.co.ke/api';

const WhoWeArePage = () => {
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/employees`);
        // Exclude superadmin (role_id 1) and admin (role_id 2)
        const filtered = response.data.filter(emp => emp.role_id > 2);
        setEmployees(filtered);
      } catch (error) {
        console.error('Failed to fetch employees', error);
      }
    };
    fetchEmployees();
  }, []);

  return (
    <div className={styles.container}>
      <PageHeader
        title="Who We Are"
        subtitle="Dedicated team serving your community by block."
      />

      <section className={styles.section}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Block</th>
              <th>Phone</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {employees.map((emp, index) => (
              <tr key={index}>
                <td>{emp.name}</td>
                <td>{emp.block}</td>
                <td>{emp.phone}</td>
                <td>{emp.email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <footer className={styles.footer}>
        <p>&copy; {new Date().getFullYear()} Kigaa Self-Help Water Society.</p>
      </footer>
    </div>
  );
};

export default WhoWeArePage;